import i18n from '../../../../lib/i18n'
import { SheetType } from '../../lib/Enums/SheetType'

export const getSingularName = (sheetType: SheetType) => {
  switch (sheetType) {
    case SheetType.BUDGET:
      return i18n.t('configuration:naming.singular.budget')
    case SheetType.ACCOUNTING:
      return i18n.t('configuration:naming.singular.accounting')
    case SheetType.SPREADSHEET:
      return i18n.t('configuration:naming.singular.spreadsheet')
  }
}

export const getImperativName = (sheetType: SheetType) => {
  switch (sheetType) {
    case SheetType.BUDGET:
      return i18n.t('configuration:naming.imperative.budget')
    case SheetType.ACCOUNTING:
      return i18n.t('configuration:naming.imperative.accounting')
    case SheetType.SPREADSHEET:
      return i18n.t('configuration:naming.imperative.spreadsheet')
  }
}
